module.exports = __webpack_public_path__ + "1dcb2c5cac341a0d205ac4388b430036.svg";


/*****************
 ** WEBPACK FOOTER
 ** ./client/assets/upicons.svg
 ** module id = 817
 ** module chunks = 0
 **/